import { sha256 } from 'js-sha256';

const test = '1Ab23Cd';
const generateTimestamp = () => Math.floor(new Date().getTime() / 1000);

export const generateSignatureHash = (data: string) => {
  const timestamp = String(generateTimestamp());
  const signature = sha256(`${test}${timestamp}${data}${test}`);
  return { signature, timestamp };
};
